import { render, staticRenderFns } from "./Leisures.vue?vue&type=template&id=744707e0&scoped=true&"
import script from "./Leisures.vue?vue&type=script&lang=js&"
export * from "./Leisures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744707e0",
  null
  
)

export default component.exports